export default "__VITE_ASSET__ClJ1SSCT__"